module.exports = __webpack_public_path__ + "img/logoifdc.886273b9.png";